import { ZModal } from "@atoms";
import React, { useEffect, useState } from "react";
import "./index.less";
import SalesActivityActionCreators from "../../../../../store/actions/SalesActivity";
import {
	SalesActivityModuleState,
	useSalesActivityModuleDispatch,
	useSalesActivityModuleSelector
} from "../../../../../store";
import { Col, Row } from "antd";
import {
	ConflictedMeetigs,
	MeetingTimeDateRange
} from "@/Contracts/Others/SalesActivity";
import ZSpin from "@molecules/ZSpin";
import ZIcon from "@atoms/ZIcon";
import ZTypography from "@atoms/ZTypography";
import moment from "moment";
import { Icons } from "@atoms/ZIcon";
import { ConflictMeetingProps } from "./interface";

const ConflictMeeting = ({
	isConflictModalVisible,
	onCancel,
	form
}: ConflictMeetingProps) => {
	const dispatch = useSalesActivityModuleDispatch();
	const [loading, setLoading] = useState<boolean>(false);
	const { ZText } = ZTypography;

	const { conflictMeetings } = useSalesActivityModuleSelector(
		(state: SalesActivityModuleState) => ({
			conflictMeetings: state.salesActivity.conflictMeetings
		})
	);

	const getFormValues = () => {
		return form.getFieldsValue([
			"start_time",
			"start_date"
		]) as MeetingTimeDateRange;
	};
	const { start_time, start_date } = getFormValues();

	const [currentDate, setCurrentDate] = useState(
		moment(start_date).format(`dddd, MMM Do`)
	);
	const [startDate, setStartDate] = useState<moment.Moment | null>(
		start_date
	);

	const getStartTime = (
		start_time: moment.Moment | null,
		start_date: moment.Moment | null
	) => {
		if (start_time && start_date) {
			const dateTime = new Date();
			dateTime.setDate(1);
			dateTime.setFullYear(start_date.year());
			dateTime.setMonth(start_date.month());
			dateTime.setDate(start_date.date());
			dateTime.setHours(start_time.hours());
			dateTime.setMinutes(start_time.minutes());
			dateTime.setSeconds(0);
			dateTime.setMilliseconds(0);

			return dateTime.valueOf();
		}
		return new Date().valueOf();
	};

	const getConflictedMeetingsDetail = async (startTime: number) => {
		setLoading(true);
		await dispatch(
			SalesActivityActionCreators.getConflictMeetingDetail(startTime)
		);
		setLoading(false);
	};

	useEffect(() => {
		if (isConflictModalVisible) {
			const startTime = getStartTime(start_time, start_date);
			getConflictedMeetingsDetail(startTime);
		}
		setLoading(false);
	}, [isConflictModalVisible]);

	const getMeetingDetailRow = (meeting: ConflictedMeetigs) => {
		const meetingTime =
			moment(meeting.start_time).format(`HH:mm a`) +
			" - " +
			moment(meeting.end_date_time).format(`HH:mm a`);

		return (
			<Row className="meeting-detail-row">
				<Col span={24} className="text-xs">
					{meetingTime}
				</Col>
				<Col span={24} className="font-medium">
					<ZText>{meeting.title}</ZText>
				</Col>
			</Row>
		);
	};

	const updateMeetingsForDate = async (date: moment.Moment) => {
		const updateCurrentDate = moment(date).format(`dddd, MMM Do`);
		setCurrentDate(updateCurrentDate);
		setStartDate(date);
		const startTime = getStartTime(start_time, date);
		getConflictedMeetingsDetail(startTime);
	};

	const handlePrev = () => {
		const prevDate = moment(startDate).subtract(1, "days");
		updateMeetingsForDate(prevDate);
	};

	const handleNext = () => {
		const nextDate = moment(startDate).add(1, "days");
		updateMeetingsForDate(nextDate);
	};

	return (
		<ZModal
			title="Scheduled Meetings"
			visible={isConflictModalVisible}
			onCancel={onCancel}
			destroyOnClose
			hideDefaultFooter
			modalBodyClassName="p-8"
			style={{ right: 285 }}
			centered={false}
			className="conflict-meeting-modal"
			maskClosable={false}
			mask={false}
		>
			<ZSpin spinning={loading}>
				<Row className="mb-6">
					<Col>{currentDate}</Col>
					<Col>
						<ZIcon
							name={Icons.CHEVRONLEFT}
							colorVariant={7}
							onClick={handlePrev}
							size="sm"
							className="cursor-pointer ml-2"
						/>
						<ZIcon
							name={Icons.CHEVRONRIGHT}
							colorVariant={7}
							onClick={handleNext}
							size="sm"
							className="cursor-pointer ml-1"
						/>
					</Col>
				</Row>
				{!!conflictMeetings?.length ? (
					conflictMeetings.map(meeting => {
						return getMeetingDetailRow(meeting);
					})
				) : (
					<ZText>No Meeting Available.</ZText>
				)}
			</ZSpin>
		</ZModal>
	);
};

export default ConflictMeeting;
